import boundStore from "@/store/bound-store";
import type { RealmSlice } from "@/store/realm-slice";
import { getDeviceInfo } from "./device-info";

type BuildErrorContextInput = {
  error?: Error;
  extra?: Record<string, unknown>;
};

export function buildErrorContext(input?: BuildErrorContextInput) {
  const now = new Date().toISOString();
  const context: Record<string, unknown> = {
    timestamp: now,
  };

  if (typeof window !== "undefined") {
    try {
      context.route = `${window.location.pathname}${window.location.search}`;
      context.userAgent = navigator.userAgent;
      context.referrer = document.referrer;

      const deviceInfo = getDeviceInfo();
      context.browser = deviceInfo.browser;
      context.browserVersion = deviceInfo.browserVersion;
      context.os = deviceInfo.os;
      context.osVersion = deviceInfo.osVersion;
      context.device = deviceInfo.device;
      context.deviceType = deviceInfo.deviceType;
      context.deviceVendor = deviceInfo.deviceVendor;
    } catch (e) {
      context.windowAccessError = e instanceof Error ? e.message : String(e);
    }
  }

  try {
    const state = boundStore.getState() as unknown as RealmSlice & {
      person?: {
        id?: number | null;
        mail?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        username?: string | null;
        keycloakId?: string | null;
        completeProfile?: boolean | null;
      } | null;
    };
    context.realm = state.realm;
    const person = state.person || null;
    if (person) {
      const user = {
        id: person.id ?? null,
        email: person.mail ?? null,
        firstName: person.firstName ?? null,
        lastName: person.lastName ?? null,
        username: person.username ?? null,
        keycloakId: person.keycloakId ?? null,
        completeProfile: person.completeProfile ?? null,
      };
      context.user = user;
    }
  } catch (e) {
    context.storeAccessError = e instanceof Error ? e.message : String(e);
  }

  if (input?.error) {
    context.errorMessage = input.error.message;
    context.errorStack = input.error.stack;
    if ((input.error as unknown as { digest?: string }).digest) {
      context.errorDigest = (input.error as unknown as { digest?: string }).digest;
    }
  }

  if (input?.extra) {
    for (const [k, v] of Object.entries(input.extra)) {
      context[k] = v;
    }
  }

  return context;
}
